import Cookies from 'js-cookie';
import DomainListModel from './DomainListModel';
import DomainModel from './DomainModel';
import UsersModel from './UsersModel';
import IntegrationsModel from './IntegrationsModel';
import ReportsModel from './ReportsModel';
import PasswordModel from './PasswordModel';
import TimezoneModel from './TimezoneModel';
import UserModel from './UserModel';
import LinkolnDomainsModel from './LinkolnDomains';
import ShortLinkolnsModel from './ShortLinkolnsModel';
import LinkolnEmailModel from './LinkolnEmailsModel';
import CartModel from './CartModel';
import AccountModel from './AccountModel';
import PreviewCardsModel from './PreviewCardsModel';
import {logIn, signUp, demoSignUp, verify} from '../services/LogIn';
import {sendContactForm} from '../services/ContactForm';
import {setAccount, unsetAccount} from '../services/Account';
import { action, actionOn, thunk } from 'easy-peasy';


const AppModel = {
  is_logged_in: false,

  account_id: 0,
  current_domain: DomainModel,
  domains: DomainListModel,
  linkoln_domains: LinkolnDomainsModel,
  short_linkolns: ShortLinkolnsModel,
  linkoln_emails: LinkolnEmailModel,
  integrations: IntegrationsModel,
  password: PasswordModel,
  timezone: TimezoneModel,
  reports: ReportsModel,
  users: UsersModel,
  user: UserModel,
  cart: CartModel,
  account: AccountModel,
  preview_cards: PreviewCardsModel,

  onGetDomains: actionOn(
    actions => actions.domains.getDomains,
    (state, _) => {
      if ((!state.current_domain || !state.current_domain.domain) && state.domains.good_domains.length) {
        if (Cookies.get("current_domain")) {
          var currentDomainName = Cookies.get("current_domain");
          state.current_domain = {
            "domain": currentDomainName,
            "status": "good",
          };
        } else if (state.account.default_domain) {
          for (const domain in state.domains.good_domains) {
            if (domain.domain === state.account.default_domain) {
              state.current_domain = domain;
            }
          }
        }
        // fall back to first domain if no valid default was found
        if (!state.current_domain || !state.current_domain.domain) {
          state.current_domain = state.domains.good_domains[0];
        }
      }
    }
  ),
  setIsLoggedIn: action((state, is_logged_in) => {
    if (state.is_logged_in !== is_logged_in) {
      state.is_logged_in = is_logged_in;
    }
  }),
  setInitialDomain: action((state, domain) => {
    state.current_domain = domain;
  }),
  setCurrentDomain: action((state, domain) => {
    if (!state.current_domain || (state.current_domain.domain !== domain.domain)) {
      state.current_domain = domain;
      Cookies.set("current_domain", state.current_domain.domain);
    }
  }),
  setAccount: action((state, account_id) => {
    state.account_id = account_id;
  }),
  changeAccount: thunk(async (actions, account_id) => {
      const response = await setAccount(account_id);
      if (response.status === "success") {
        actions.setAccount(account_id);
      }
  }),
  unchangeAccount: thunk(async (actions) => {
      const response = await unsetAccount();
      if (response.status === "success") {
        actions.setAccount(0)
      }
  }),
  logIn: thunk(async (actions, payload) => {
    const response = await logIn(payload.username, payload.password);
    if (response.success) {
      actions.setIsLoggedIn(true);
    }
    return response;
  }),
  signUp: thunk(async (_, payload) => {
    console.log(payload);
    const response = await signUp(payload.email, payload.first_name, payload.last_name, payload.signup_code, payload.domain, payload.subdomain);
    return response;
  }),
  demoSignUp: thunk(async (_, payload) => {
    const response = await demoSignUp(payload.email);
    return response;
  }),
  verifyAccount: thunk(async (_, payload) => {
    const response = await verify(payload.code, payload.password);
    return response;
  }),
  submitContactForm: thunk(async (_, payload) => {
    const response = await sendContactForm(payload);
    return response;
  }),
}

export default AppModel;

